<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Border Lord</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm03"><a id="page06"><div class="chapterHead"><h2 class="chapterTitle2"><span class="bold"><span>DON’T MISS THESE OTHER NOVELS AVAILABLE NOW:</span></span></h2></div><div class="chapterBody"><p class="paraCenter"><span><span class="bold"><span>#943 THE DIAMONDS OF WELBOURNE MANOR—Diane Gaston, Deb Marlowe, Amanda McCabe</span></span></span></p><p class="paraCenter"><span>Welcome to Welbourne Manor! In this lush family home a Regency house party is in full swing. Join three beautiful sisters, Justine, Annalise and Charlotte, as they each discover something more precious than diamonds—husbands!</span></p><p class="lineSpace1"><span> </span></p><p class="paraCenter"><span><span class="bold"><span>#944 HIS FORBIDDEN LIAISON—Joanna Maitland</span></span></span></p><p class="paraCenter"><span>Notorious Jack Aikenhead has never wanted for female company…until he meets feisty Marguerite Grolier, and realizes she’s the <em class="italic"><span>only</span></em> woman he needs. Although they have been thrown together by circumstance, the reckless rake transforms into an honorable knave, for love!</span></p><p class="paraCenter"><span><em class="italic"><span>Third in The Aikenhead Honors trilogy—three gentlemen spies: bound by duty, undone by women!</span></em></span></p><p class="lineSpace1"><span> </span></p><p class="paraCenter"><span><span class="bold"><span>#945 THE CATTLEMAN’S UNSUITABLE WIFE—Pam Crooks</span></span></span></p><p class="paraCenter"><span>Ruthless Montana rancher Trey Wells has never met a woman who ignites his passion so much as exotic beauty Zurina Vasco. Despite all that separates them, can Trey give Zurina the love, respectability and true home she deserves?</span></p></div></a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// borderlordthe_fm03.vue?25f4bcf9